import users from '@/data/common/users'

export default [
    {
        id: 2069,
        name: null,
        options: [
            {
                id: 9625,
                user: users['2'],
                email: users['2'].email,
            },
            {
                id: 9626,
                user: users['719'],
                email: users['719'].email,
            },
            {
                id: 9632,
                user: users['1'],
                email: users['1'].email,
            },
        ],
    },
    {
        id: 2070,
        name: 'Elétrica',
        options: [
            {
                id: 9627,
                user: users['155'],
                email: users['155'].email,
            },
            {
                id: 9628,
                user: users['58'],
                email: users['58'].email,
            },
        ],
    },
    {
        id: 2071,
        name: 'Hidráulica',
        options: [
            {
                id: 9629,
                user: users['131'],
                email: users['131'].email,
            },
        ],
    },
]
